var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCampaign = function SvgCampaign(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.999 15.001 6.998 15a4.003 4.003 0 0 1-4.002-4.004v-.997A4.002 4.002 0 0 1 7 5.995h7l3.874-2.647c1.329-.907 3.13.044 3.13 1.653v10.997c0 1.608-1.802 2.56-3.13 1.651L14 15.001Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14 5.997v9.004M5.998 15.001l1.53 3.86a1.8 1.8 0 0 0 1.67 1.142v0c1.271 0 2.142-1.294 1.672-2.488l-.989-2.514"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCampaign);
export default ForwardRef;